
    var riot = require('riot')
    riot.tag2('gb-sayt-link', '<a onclick="{opts.send}"> <yield></yield> </a>', 'gb-sayt-link.gb-stylish > a,[data-is="gb-sayt-link"].gb-stylish > a{ padding: 5px 15px; text-decoration: none; display: block; }', '', function(opts) {
});

    
  


// WEBPACK FOOTER //
// ./src/tags/sayt/gb-sayt-link.tag.html